import { Tooltip, Typography } from '@mui/material'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'
import CommentIcon from '@mui/icons-material/Comment'

interface CommentCellHeaderProps {
  densityStyles: DensityStyleTypes
}

const CommentCellHeader: FC<CommentCellHeaderProps> = ({ densityStyles }) => {
  return (
    <Tooltip title={<Typography sx={{ fontSize: densityStyles.fontSize }}>Comments</Typography>}>
      <CommentIcon sx={{ height: densityStyles.iconSize, width: densityStyles.iconSize }} />
    </Tooltip>
  )
}
export default CommentCellHeader
